export const RoleData = [
	{
	  label: '관리자관리',
	  value: 'admin',
	},
	{
	  label: '단말관리',
	  value: 'devices',
	},
	{
	  label: '사용자관리',
	  value: 'users',
	},
	// {
	//   label: 'F/W관리',
	//   value: 'firmwares',
	// },
];

export const formatNumber = (data) => {
  // 소수점 자릿수가 있을 경우만 둘째 자리까지 표시
  return data % 1 === 0 ? data : Number(data).toFixed(2);
}

export const replaceNumber = (data) => {
	return data.toString().replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");;
}

export const isBase64Encoded = (str) => {
  // Base64 포맷에 해당하는지 확인 (4의 배수 길이, 특정 문자 조합)
  return /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/.test(
    str
  );
};

export const dateFormat = (date) => {
	let month = date.getMonth() + 1;
	let day = date.getDate();
	let hour = date.getHours();
	let minute = date.getMinutes();
	let second = date.getSeconds();

	month = month >= 10 ? month : '0' + month;
	day = day >= 10 ? day : '0' + day;
	// hour = hour >= 10 ? hour : '0' + hour;

	let ampm = hour >= 12 ? 'PM' : 'AM';
	hour = hour % 12;
	hour = hour ? (hour >= 10 ? hour : '0' + hour) : 12; // the hour '0' should be '12'

	minute = minute >= 10 ? minute : '0' + minute;
	second = second >= 10 ? second : '0' + second;

	return date.getFullYear() + '-' + month + '-' + day + ' ' + hour + ':' +minute + ':' + second + ' ' + ampm; 
}
